import React, { useState } from 'react';
import './Forum.css';
import CreatePostModal from '../../components/Forum/CreatePostModal';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const Forum = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showCategoryFilter, setShowCategoryFilter] = useState(false);
  const [posts, setPosts] = useState([]);

  // 分区类别列表，与CreatePostModal中保持一致
  const categories = [
    { id: 'all', name: '全部' },
    { id: 'hot', name: '热门活动' },
    { id: 'mentor', name: '工作室收徒' },
    { id: 'qa', name: '你问我答' },
    { id: 'share', name: '分享海龟汤' },
    { id: 'birthday', name: '生日祝福' }
  ];

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmitPost = (postData) => {
    const newPost = {
      id: posts.length + 1,
      title: postData.title,
      content: postData.content,
      author: "当前用户",
      date: new Date().toISOString().split('T')[0],
      likes: 0,
      comments: 0,
      views: 0,
      category: postData.section
    };
    setPosts([newPost, ...posts]);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // 搜索功能实现
    console.log("搜索:", searchTerm);
  };

  // 根据分类和搜索词筛选帖子
  const filteredPosts = posts.filter(post => {
    // 分类筛选
    const categoryMatch = selectedCategory === 'all' || post.category === selectedCategory;
    
    // 搜索词筛选
    const searchMatch = searchTerm === '' || 
                       post.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                       post.content.toLowerCase().includes(searchTerm.toLowerCase());
    
    return categoryMatch && searchMatch;
  });

  return (
    <div className="elegant-app">
      <Header />
      <div className="elegant-main">
        <div className="forum-container">
          <div className="forum-header">
            <h1 className="forum-title">灌汤社区 论坛</h1>
            <p>加入我们的讨论，分享你的项目和想法</p>
            
            <div className="forum-actions">
              <button className="create-post-button" onClick={openModal}>
                <i className="fas fa-edit"></i> 发布帖子
              </button>
              
              <div className="forum-search">
                <form onSubmit={handleSearch}>
                  <input 
                    type="text" 
                    placeholder="搜索帖子" 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <button type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </form>
              </div>
              
              <div className="forum-category-filter">
                <button 
                  className="filter-toggle-button"
                  onClick={() => setShowCategoryFilter(!showCategoryFilter)}
                >
                  筛选 <i className="fas fa-filter"></i>
                </button>
                
                {showCategoryFilter && (
                  <div className="category-dropdown">
                    {categories.map(category => (
                      <button
                        key={category.id}
                        className={`category-option ${selectedCategory === category.id ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedCategory(category.id);
                          setShowCategoryFilter(false);
                        }}
                      >
                        {category.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="posts-list">
            {filteredPosts.length > 0 ? (
              filteredPosts.map(post => (
                <div className="forum-post-item" key={post.id}>
                  <div className="post-main-content">
                    <h2 className="post-title">{post.title}</h2>
                    <div className="post-meta">
                      <div className="post-author">
                        <i className="fas fa-user"></i> {post.author}
                      </div>
                      <div className="post-date">
                        <i className="fas fa-calendar"></i> {post.date}
                      </div>
                      <div className="post-category">
                        <i className="fas fa-tag"></i> 
                        {categories.find(cat => cat.id === post.category)?.name || '未分类'}
                      </div>
                    </div>
                    <p className="post-content">{post.content}</p>
                  </div>
                  <div className="post-meta-container">
                    <div className="post-stats">
                      <div className="post-views">
                        <i className="fas fa-eye"></i> {post.views}
                      </div>
                      <div className="post-likes">
                        <i className="fas fa-heart"></i> {post.likes}
                      </div>
                      <div className="post-comments">
                        <i className="fas fa-comment"></i> {post.comments}
                      </div>
                    </div>
                    <a href="#" className="read-more">
                      查看详情 <i className="fas fa-angle-right"></i>
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-posts-message">
                <i className="fas fa-info-circle"></i> 
                没有找到符合条件的帖子
              </div>
            )}
          </div>

          <CreatePostModal 
            isOpen={isModalOpen} 
            onClose={closeModal} 
            onSubmit={handleSubmitPost} 
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Forum; 